import React from 'react';

/** Default uppercase mono labels so meaning is never encoded by color alone. */
const STATUS_LABELS = {
  success: 'Validated',
  error: 'Conflict',
  info: 'Info',
  warning: 'Review',
};

const CONFIDENCE_LABELS = {
  high: 'High confidence',
  medium: 'Medium confidence',
  low: 'Low confidence',
  insufficient_evidence: 'Insufficient evidence',
};

/**
 * Status/confidence pill with dot icon + uppercase mono label.
 * Pass either `status` (success|error|info|warning) or `confidence`
 * (high|medium|low|insufficient_evidence). `label` overrides the default text.
 */
export function Badge({ status, confidence, label, className = '', ...rest }) {
  const modifier = confidence
    ? `opt-badge--confidence-${confidence}`
    : status
      ? `opt-badge--${status}`
      : '';

  const defaultLabel = confidence
    ? CONFIDENCE_LABELS[confidence]
    : STATUS_LABELS[status];

  const classes = ['opt-badge', modifier, className].filter(Boolean).join(' ');

  return (
    <span className={classes} {...rest}>
      <span className="opt-badge__dot" aria-hidden="true" />
      <span className="opt-badge__label">{label || defaultLabel || 'Status'}</span>
    </span>
  );
}

export default Badge;
